import EndPointConfig from '../../models/api/endPointConfig';

const controller = 'Balances';

/// Define all EndPoints for contact section.
export const ExchangeEP: EndPointConfig[] = [
    // Envio de formulario a la API

    new EndPointConfig()
        .setMethod('GET')
        .setController(controller)
        .setAlias('GetAvailableBalances'),

    new EndPointConfig()
        .setMethod('GET')
        .setController(controller)
        .setPattern('{currency}/bankDetails')
        .setAlias('GetBankDetailsByCurrency'),

    new EndPointConfig()
        .setMethod('GET')
        .setController(controller)
        .setPattern('{id}/deposits')
        .setAlias('GetDeposits'),

    new EndPointConfig()
        .setMethod('DELETE')
        .setController(controller)
        .setPattern('{id}/deposits')
        .setAlias('RemoveDeposits'),

    new EndPointConfig()
        .setMethod('POST')
        .setController(controller)
        .setPattern('{idCurrency}/deposits')
        .setAlias('AddDeposits'),

];